// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import BAdminEntity from 'granite-admin/common/entities/businessAdmin';
const url = process.env.REACT_APP_ORGANISATION_BASE_URL;
const mapToSnakeCase = data => {
  const payload = {
    user: {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      phone: `+${data.phone.number}`
    },
    extra_data: data.extraData,
    roles: [data.groupBy]
  };
  return payload;
};
async function getBAdmins(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/business-admin/', payload);
    if (!params.export) {
      const list = data ? data.results.map(item => new BAdminEntity(item)) : [];
      return {
        list,
        count: data.count
      };
    } else {
      return data;
    }
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
async function getBAdminsRoles(params, signal) {
  const payload = {
    params,
    signal
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('/business-admin/roles/', payload);
    if (!params.export) {
      return {
        list: data.results,
        count: data.count
      };
    } else {
      return data;
    }
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
async function createBAdminsRole(values) {
  let payload = {
    name: values.name,
    permissions: []
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).post('/business-admin/roles/', payload);
    return data;
  } catch (error) {
    throw error;
  }
}
async function editBAdminsRole(pk, name, permissions, type) {
  let payload = type === 'name' ? {
    name
  } : type === 'permissions' ? {
    name,
    permissions
  } : {};
  try {
    const {
      data
    } = await GraniteAPIClient(url).put(`/business-admin-role/${pk}/`, payload);
    return data;
  } catch (error) {
    throw error;
  }
}
async function updateBAdmin(payload) {
  try {
    let response;
    if (payload.pk) {
      response = await GraniteAPIClient(url).put(`/business-admin/${payload.pk}/`, mapToSnakeCase(payload));
    } else {
      response = await GraniteAPIClient(url).post('/business-admin/', mapToSnakeCase(payload));
    }
    return response;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteBAdmin(pk) {
  try {
    const response = await GraniteAPIClient(url).delete(`/business-admin/${pk}/`);
    return response;
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
async function getBAdminById(id) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/business-admin/${id}/`);
    if (data) {
      return new BAdminEntity(data);
    }
    return {};
  } catch (e) {
    throw new GraniteError(e.errors);
  }
}
export { getBAdminById, updateBAdmin, deleteBAdmin, getBAdmins, getBAdminsRoles, createBAdminsRole, editBAdminsRole };